export default __webpack_public_path__ + "static/media/ExportLog.c97cbd7a.svg";